export const CONSUMED_COUPON_INFO = 'CONSUMED_COUPON_INFO'
export const UPDATE_COUPON_INFO_RECORD = 'UPDATE_COUPON_INFO_RECORD'
export const UPDATE_COUPON_INFO_FALSE_RECORD = 'UPDATE_COUPON_INFO_FALSE_RECORD'



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-consuming-records/store/mutations-types.js